import CopyableText from "components/common/CopyableText";
import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

const formatDate = (value) => {
  if (!value) return "None";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Invalid date";
  return date.toLocaleString();
};

const Field = ({ label, value }) => (
  <div className="d-flex flex-column gap-1">
    <strong>{label}:</strong>
    <div>{value}</div>
  </div>
);

export default function UserDeletionViewModal({ show, onClose, request, loading }) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="modal-small-text"
      backdrop="static"
      keyboard
    >
      <Modal.Header className="py-3 fw-bold" style={{ fontSize: 14 }}>
        User Deletion Request Details
      </Modal.Header>

      <Modal.Body style={{ fontSize: "0.85rem" }}>
        {loading ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: 120 }}
          >
            <Spinner animation="border" variant="success" />
          </div>
        ) : request ? (
          <div className="d-flex flex-column gap-3">
            <Field label="Request ID" value={<CopyableText value={request.id} />} />
            <Field label="User ID" value={<CopyableText value={request.userId} />} />
            <Field label="Status" value={request.status || "None"} />
            <Field label="Deletion Reason" value={request.deletionReason || "None"} />
            <Field label="Failure Reason" value={request.failureReason || "None"} />
            <Field
              label="Requested At"
              value={formatDate(request.requestedAt)}
            />
            <Field
              label="Deletion Scheduled At"
              value={formatDate(request.deletionScheduledAt)}
            />
            <Field label="Deleted At" value={formatDate(request.deletedAt)} />
          </div>
        ) : (
          <p>No data available</p>
        )}
      </Modal.Body>

      <div className="p-3 d-flex justify-content-end">
        <Button size="sm" variant="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
}
